import React from "react";
import PropTypes from "prop-types";
import mask from "~services/utils/mask";

const PriceSearchHeader = ({ dados }) => {
  const { formatNumerFix } = mask();

  return (
    <div className="bg-terciaria full-screen-width" data-testid="price-search-header">
      <div className="flex space-x-4 p-4 text-white container">
        <div className="w-full">
          {dados && (
            <>
              {dados.codigo && dados.nomeFantasia && (
                <p className="font-bold text-xl">
                  {dados.codigo} - {dados.nomeFantasia}{" "}
                </p>
              )}
              <div className="columns-2 mt-4">
                {dados?.endereco?.rua && (
                  <p>
                    Endereço:{" "}
                    <strong>{`${dados.endereco.rua} ${dados.endereco.numero ?? ""} ${
                      dados.endereco.complemento ?? ""
                    } ${dados.endereco.bairro ?? ""}`}</strong>
                  </p>
                )}

                {dados?.endereco?.cidade?.nome && (
                  <p>
                    Cidade: <strong>{dados.endereco.cidade.nome}</strong>
                    {dados?.cluster?.nome && <> Cluster ({dados.cluster.nome})</>}
                  </p>
                )}

                {dados?.microrregiao && (
                  <p>
                    Micro Região: <strong>{dados.microrregiao}</strong>
                  </p>
                )}

                {dados?.segmento && (
                  <p>
                    Segmento Desc: <strong>{dados.segmento}</strong>
                  </p>
                )}

                {dados?.telefone && (
                  <p>
                    Telefone: <strong>{formatNumerFix(dados.telefone)}</strong>
                  </p>
                )}

                {dados?.celular && (
                  <p>
                    Celular: <strong>{formatNumerFix(dados.celular)}</strong>
                  </p>
                )}

                {dados?.suframa && (
                  <p>
                    Cliente com SUFRAMA: <strong>{dados.suframa}</strong>
                  </p>
                )}

                {dados?.duplaCategoria && (
                  <p>
                    Cliente com Dupla Categoria: <strong>{dados.duplaCategoria ? "Sim" : "Não"}</strong>
                  </p>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

PriceSearchHeader.propTypes = {
  dados: PropTypes.shape({
    codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nomeFantasia: PropTypes.string,
    endereco: PropTypes.shape({
      rua: PropTypes.string,
      numero: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      complemento: PropTypes.string,
      bairro: PropTypes.string,
      cidade: PropTypes.shape({
        nome: PropTypes.string,
      }),
    }),
    cluster: PropTypes.shape({
      nome: PropTypes.string,
    }),
    microrregiao: PropTypes.string,
    segmento: PropTypes.string,
    telefone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    celular: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    suframa: PropTypes.string,
    duplaCategoria: PropTypes.bool,
  }),
};

PriceSearchHeader.defaultProps = {
  dados: null,
};

export default PriceSearchHeader;
